export default {
  setAccount(context, account) {
    context.commit('setAccount', account)
  },

  setAccounts(context, accounts) {
    context.commit('setAccounts', accounts)
  }
}
